import { formatFramework } from '@sdd-maturity/shared-types';

/** Badge showing the detected SDD framework for a repository (AC-9.5, AC-6.2) */
export function FrameworkBadge({ framework }: { framework: string }) {
  if (!framework || framework === 'none' || framework === 'unknown') {
    return (
      <span className="badge badge-warning" data-testid="framework-badge">
        No Framework
      </span>
    );
  }

  // AC-6.2: Distinct badges for maintenance-only and infra-only
  if (framework === 'maintenance-only') {
    return (
      <span className="badge badge-maintenance" data-testid="framework-badge">
        Maintenance Only
      </span>
    );
  }

  if (framework === 'infra-only') {
    return (
      <span className="badge badge-infra" data-testid="framework-badge">
        Infrastructure Only
      </span>
    );
  }

  // Display-label lookup (spec #631, AC-3): render the human-readable name
  // (e.g. 'pdlc' → 'SDD-PDLC') AFTER the special-case branches above, so the
  // 'none'/'unknown'/'maintenance-only'/'infra-only' fallbacks are untouched.
  return (
    <span className="badge badge-info" data-testid="framework-badge">
      {formatFramework(framework)}
    </span>
  );
}
